import { useState } from 'react';
import { useSerivePointTypes } from '../../../features/servicePointType/useServicePointType';

export const useOnUpdatePostClicked = (formState = {}, id) => {

    const { updateSerivePointType } = useSerivePointTypes();
    const [response, setResponse] = useState();
    const [loading, setLoading] = useState(false);
    const [formError, setformError] = useState();
    const onUpdatePostClicked = async () => {
        setLoading(true);
        try {
            const formData = {
                id: formState.id,
                name: formState.name,
            };
            const response = await updateSerivePointType(id, formData);
            setResponse(response);
            setformError(response.errors)
        } catch (error) {
            const errorResponse = error?.data?.errors || { message: 'Bilinmeyen hata oluştu' };
            setResponse(errorResponse);
            return errorResponse;
        } finally {
            setLoading(false);
        }
    };

    return {
        response,
        loading,
        formError,
        onUpdatePostClicked,
    };
};
